"use client";
import { jsx as e, jsxs as r } from "react/jsx-runtime";
import { Close as p } from "@videoblocks/react-icons";
import { Dialog as f, DialogContent as g, DialogHeader as u, DialogTitle as C, DialogClose as o, DialogDescription as x, DialogFooter as D } from "../../atoms/Dialog/Dialog.mjs";
import { Text as y } from "../../atoms/Text/Text.mjs";
import { Button as i } from "../../atoms/Button/Button.mjs";
import { cn as N } from "../../../utils/utils.mjs";
const B = ({
  isOpen: a,
  title: t,
  content: l,
  onCancel: n,
  onConfirm: s,
  confirmLabel: c = "Confirm",
  cancelLabel: d = "Cancel",
  className: m
}) => /* @__PURE__ */ e(f, { open: a, onOpenChange: (h) => !h && n(), children: /* @__PURE__ */ r(
  g,
  {
    className: N("gap-10 p-8 rounded-sm border-0 dark:bg-neutral-dark-1000", m),
    showCloseButton: !1,
    children: [
      /* @__PURE__ */ r(u, { className: "flex-row items-center justify-between text-gray-900", children: [
        /* @__PURE__ */ e(C, { fontSize: "2xl", children: t }),
        /* @__PURE__ */ e(
          o,
          {
            className: "opacity-70 hover:opacity-100 transition-opacity cursor-pointer",
            "aria-label": "close",
            children: /* @__PURE__ */ e(p, { className: "w-4 h-4 fill-current" })
          }
        )
      ] }),
      /* @__PURE__ */ e(x, { asChild: !0, children: /* @__PURE__ */ e(y, { fontSize: "base", fontWeight: "regular", className: "text-gray-900", children: l }) }),
      /* @__PURE__ */ r(D, { className: "gap-4", children: [
        /* @__PURE__ */ e(o, { asChild: !0, children: /* @__PURE__ */ e(i, { variant: "outlined-dark", children: d }) }),
        /* @__PURE__ */ e(i, { onClick: s, children: c })
      ] })
    ]
  }
) });
export {
  B as ConfirmationModal
};
